import { Controller } from '@hotwired/stimulus'

// I-APPS-01 „Kopírovat“: copies the source field's value and confirms on the button. Without clipboard access
// (plain http, denied permission) the text is selected instead, so Ctrl+C still works.
export default class ClipboardController extends Controller<HTMLElement> {
  static override targets = ['source', 'button']
  static override values = { copied: String }
  declare readonly sourceTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly copiedValue: string
  private timer: number | undefined

  async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
    } catch {
      this.sourceTarget.select()
      return
    }
    const label = this.buttonTarget.dataset['label'] ?? this.buttonTarget.textContent ?? ''
    this.buttonTarget.dataset['label'] = label
    this.buttonTarget.textContent = this.copiedValue
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => (this.buttonTarget.textContent = label), 2000)
  }

  override disconnect(): void {
    window.clearTimeout(this.timer)
  }
}
